/*
 * @Description:
 * @Version: 2.0
 * @Autor: xiangqingqing
 * @Date: 2022-09-23 15:15:00
 * @LastEditors: xiangqingqing
 * @LastEditTime: 2022-10-21 09:28:26
 */
import { TUserInfoType } from "@/module/login";
import { reactive, ref } from "vue";

export const menuList = reactive([{
    id: 1,
    name: '首页',
    path: "teaIndex",
    isSelect: false
}, {
    id: 2,
    name: '专题直播',
    path: "liveBroadcast",
    isSelect: false
}, {
    id: 3,
    name: '资料库',
    path: "database",
    isSelect: false
}, {
    id: 6,
    name: '任务中心',
    path: "task",
    isSelect: false,
}, {
    id: 7,
    name: '数据监控',
    path: "dataMonitor",
    isSelect: false,
}, {
    id: 5,
    name: '数据中心',
    path: "",
    isSelect: false,
}]);
// 获取当前用户信息
let person = reactive({
    userInfo: <TUserInfoType>{}
})
const menu = ref<any>(null)

export function getMenuData(){
    person.userInfo = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo"))));
    menuList.forEach((item: any) => {
        if (item.id === 1) {
            item.isShow = person.userInfo.RecordIsShow
            item.content = '1'
        } else if (item.id === 2) {
            item.isShow = person.userInfo.LiveIsShow
            item.content = '1'
        } else if (item.id === 3) {
            item.isShow = person.userInfo.FileIsShow
            item.content = '1'
        } else if (item.id === 4) {
            item.isShow = person.userInfo.EquipmentIsShow
            item.content = '1'
        }
        // else if(item.id===5){
        //     item.isShow = person.userInfo.DataIsShow
        //     item.content = person.userInfo.DataUrl
        //     item.path=person.userInfo.DataUrl
        // }
        // else if(item.id===6){
        //     item.isShow = person.userInfo.TaskIsShow
        //     item.content = '1'
        // }
        // else if(item.id===7){
        //     item.isShow = person.userInfo.DataMonitorIsShow
        //     item.content = '1'
        // }
    })
    const menuLists = menuList.filter((item: any) => { if (item.isShow && item.content) { return item } })
    const indexs = Number(localStorage.getItem('navIndex'))
    if (indexs){
        menuLists[indexs].isSelect = true
    }else{
        menuLists[0].isSelect=true
    }
    menu.value = menuLists
    return menuLists
}

export { menu }




